import styles from '../Overview.module.scss';

const { geoMapUs, geoMapEurope, geoMapAustralia } = styles;

export interface IactivitiesList {
	activityTitle: string;
	activityDescription: string;
	date: string;
	time: string;
	status: string;
	name: string;
	mail: string;
	id: string | number;
}
export const activitiesList = [
	{
		activityTitle: 'Activity Log',
		activityDescription: 'action log description text goes here - processing',
		date: '12 Nov 2023',
		time: '9:10:03PM',
		status: 'Processing',
		name: 'Grand Rapids',
		mail: 'grandrapids@email.com',
		id: 1,
	},
	{
		activityTitle: 'Activity Log',
		activityDescription: 'action log description text goes here - processing',
		date: '12 Nov 2023',
		time: '9:10:03PM',
		status: 'Processing',
		name: 'Grand Rapids',
		mail: 'grandrapids@email.com',
		id: 2,
	},
	{
		activityTitle: 'Activity Log',
		activityDescription: 'action log description text goes here - processing',
		date: '12 Nov 2023',
		time: '9:10:03PM',
		status: 'Failed',
		name: 'Grand Rapids',
		mail: 'grandrapids@email.com',
		id: 3,
	},
	{
		activityTitle: 'Activity Log',
		activityDescription: 'action log description text goes here - processing',
		date: '12 Nov 2023',
		time: '9:10:03PM',
		status: 'Failed',
		name: 'Grand Rapids',
		mail: 'grandrapids@email.com',
		id: 4,
	},
	{
		activityTitle: 'Activity Log',
		activityDescription: 'action log description text goes here - processing',
		date: '12 Nov 2023',
		time: '9:10:03PM',
		status: 'Success',
		name: 'Grand Rapids',
		mail: 'grandrapids@email.com',
		id: 5,
	},
	{
		activityTitle: 'Activity Log',
		activityDescription: 'action log description text goes here - processing',
		date: '12 Nov 2023',
		time: '9:10:03PM',
		status: 'Success',
		name: 'Grand Rapids',
		mail: 'grandrapids@email.com',
		id: 6,
	},
	{
		activityTitle: 'Activity Log',
		activityDescription: 'action log description text goes here - processing',
		date: '12 Nov 2023',
		time: '9:10:03PM',
		status: 'Processing',
		name: 'Grand Rapids',
		mail: 'grandrapids@email.com',
		id: 7,
	},
	{
		activityTitle: 'Activity Log',
		activityDescription: 'action log description text goes here - processing',
		date: '12 Nov 2023',
		time: '9:10:03PM',
		status: 'Processing',
		name: 'Grand Rapids',
		mail: 'grandrapids@email.com',
		id: 8,
	},
	{
		activityTitle: 'Activity Log',
		activityDescription: 'action log description text goes here - processing',
		date: '12 Nov 2023',
		time: '9:10:03PM',
		status: 'Success',
		name: 'Grand Rapids',
		mail: 'grandrapids@email.com',
		id: 15,
	},
	{
		activityTitle: 'Activity Log',
		activityDescription: 'action log description text goes here - processing',
		date: '12 Nov 2023',
		time: '9:10:03PM',
		status: 'Processing',
		name: 'Grand Rapids',
		mail: 'grandrapids@email.com',
		id: 14,
	},
	{
		activityTitle: 'Activity Log',
		activityDescription: 'action log description text goes here - processing',
		date: '12 Nov 2023',
		time: '9:10:03PM',
		status: 'Success',
		name: 'Grand Rapids',
		mail: 'grandrapids@email.com',
		id: 13,
	},
	{
		activityTitle: 'Activity Log',
		activityDescription: 'action log description text goes here - processing',
		date: '12 Nov 2023',
		time: '9:10:03PM',
		status: 'Processing',
		name: 'Grand Rapids',
		mail: 'grandrapids@email.com',
		id: 12,
	},
	{
		activityTitle: 'Activity Log',
		activityDescription: 'action log description text goes here - processing',
		date: '12 Nov 2023',
		time: '9:10:03PM',
		status: 'Success',
		name: 'Grand Rapids',
		mail: 'grandrapids@email.com',
		id: 11,
	},
	{
		activityTitle: 'Activity Log',
		activityDescription: 'action log description text goes here - processing',
		date: '12 Nov 2023',
		time: '9:10:03PM',
		status: 'Failed',
		name: 'Grand Rapids',
		mail: 'grandrapids@email.com',
		id: 10,
	},
];

export const OverviewTabsList = [
	{ count: '33', label: 'All Activities', value: '1' },
	{ count: '15', label: 'Success', value: '2' },
	{ count: '8', label: 'Failed', value: '3' },
];

export const maplabelData = [
	{
		color: geoMapUs,
		text: 'United States',
		digit: '5',
		cssColor: 'blue',
	},
	{
		color: geoMapEurope,
		text: 'Europe',
		digit: '21',
		cssColor: 'darkblue',
	},
	{
		color: geoMapAustralia,
		text: 'Australia',
		digit: '7',
		cssColor: 'lightblue',
	},
];
